/* Pink button letter wave (Chris, 2026-09-29: "Put the animated text into every pink button on the site").
   Splits each text-only .ely-button--pink into per-letter spans, the same markup as snippets/elysian-nav-label.liquid, so the
   letters lift in a small wave on hover and keyboard focus (styles in elysian.css). The accessible name stays the whole label.
   Buttons that already carry the split label (the hero) or contain other elements are left alone. Without JS: plain buttons. */
(function () {
  function split(b) {
    b.setAttribute('data-wave', '');
    if (b.children.length) return;
    var t = b.textContent.replace(/\s+/g, ' ').trim();
    if (!t) return;
    var n = t.length, st = n > 8 ? Math.floor(160 / n) + 1 : 22;
    var outer = document.createElement('span'); outer.className = 'ely-nh'; outer.style.setProperty('--nh-st', st + 'ms');
    var vh = document.createElement('span'); vh.className = 'visually-hidden'; vh.textContent = t;
    var w = document.createElement('span'); w.className = 'ely-nh__word'; w.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < n; i++) {
      var l = document.createElement('span'); l.className = 'ely-nh__l'; l.style.setProperty('--i', i); l.textContent = t[i]; w.appendChild(l);
    }
    outer.appendChild(vh); outer.appendChild(w);
    b.textContent = ''; b.appendChild(outer);
  }
  var SEL = '.ely-button--pink:not([data-wave])';
  function run(root) { root.querySelectorAll(SEL).forEach(split); }
  function start() {
    run(document);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches(SEL)) split(node);
          run(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
